// import React from "react";
// import frameImg1 from './Images/frame1.png';
// import frameImg2 from './Images/frame2.png';
// import frameImg3 from './Images/frame3.png';
// import frameImg4 from './Images/frame4.png';
// import frameImg5 from './Images/frame5.png';

// const laneItems = [
//   // 1
//   { kind: "single", tone: "g-orange", kpi: "75M+", text: "Served with love by our creators" },

//   // 2 (stack: small image + double cyan)
//   {
//     kind: "stack",
//     top: {
//       tone: "g-amber",
//       img: "https://picsum.photos/id/1011/420/560",
//       caption: "All night live",
//     },
//     bottom: {
//       tone: "g-cyan",
//       kpi: "75M+",
//       text: "Served with love by our creators",
//       variant: "double",
//     },
//   },

//   // 3
//   { kind: "single", tone: "g-teal", kpi: "75M+", text: "Served with love by our creators" },

//   // 4 (stack: small image + double orange)
//   {
//     kind: "stack",
//     top: {
//       tone: "g-amber",
//       img: "https://picsum.photos/id/1011/420/560",
//       caption: "All night live",
//     },
//     bottom: {
//       tone: "g-orange",
//       kpi: "75M+",
//       text: "Served with love by our creators",
//       variant: "double",
//     },
//   },

//   // 5
//   { kind: "single", tone: "g-orange", kpi: "75M+", text: "Served with love by our creators" },

//   // 6 (stack: double blue + double magenta)
//   {
//     kind: "stack",
//     top: {
//       tone: "g-blue",
//       kpi: "75M+",
//       text: "Served with love by our creators",
//       variant: "double",
//     },
//     bottom: {
//       tone: "g-magenta",
//       kpi: "75M+",
//       text: "Served with love by our creators",
//       variant: "double",
//     },
//   },

//   // 7 (single image amber)
//   {
//     kind: "image",
//     tone: "g-amber",
//     img: "https://picsum.photos/id/1011/420/560",
//     caption: "All night live",
//   },
// ];

// const GridCardSection = () => {
//   return (
//     <section className="py-5 bg-light">
//       {/* reference-style inner wrapper */}
//       <div
//         className="px-5 x-xxl-5 px-6 mx-auto position-relative"
//         style={{ maxWidth: "88%", zIndex: 1, marginTop: 60 }}
//       >
//         {/* ===== Heading + Content ===== */}
//         <div style={{
//          marginTop: "-4rem",   
//           marginBottom: "8rem"
//         }}
//         >
//           <h2
//             style={{
//               fontSize: "2.5rem",
//               fontFamily: "Inter",
//               fontWeight: 700,
//               color: "#242121ff",
//               lineHeight: 1.2,
//             }}
//           >
//             How can business{" "}
//             <span
//               style={{
//                 color: "#1DB954",
//                 fontFamily: "Inter",
//                 fontWeight: 700,
//               }}
//             >
//               boost engagement?
//             </span>
//           </h2>
//           <p
//             style={{
//               marginTop: -2,
//               color: "#413e3eff",
//               fontSize: "1.1rem",
//               fontFamily: "Poppins",
//               fontWeight: 300,
//               lineHeight: 1.2,
//             }}
//           >
//             With sector-specific solutions crafted to enhance customer journeys
//             and maximize results.
//           </p>
//         </div>
//         <div className="container-fluid">
//           {/* Lane 1 */}
//           <div className="vx-marquee mb-5" style={{ ["--dur"]: "15s" }}>
//             <div className="vx-track">
//               {/* render items twice for seamless looping */}
//               {[0, 1].map((dup) => (
//                 <React.Fragment key={dup}>
//                   {laneItems.map((item, idx) => {
//                     const key = `${dup}-${idx}`;

//                     if (item.kind === "single") {
//                       return (
//                         <div key={key} className={`vx-card single ratio ratio-4x5 text-white ${item.tone}`}>
//                           <div className="p-4 d-flex flex-column justify-content-end">
//                             <div className="display-5 fw-bold lh-1">{item.kpi}</div>
//                             <div className="small mt-2 opacity-75">{item.text}</div>
//                           </div>
//                         </div>
//                       );
//                     }

//                     if (item.kind === "image") {
//                       return (
//                         <div key={key} className={`vx-card ratio mt-2 ratio-4x5 text-white ${item.tone}`}>
//                           <img className="vx-bg-img" src={item.img} alt={item.caption} />
//                           <div className="p-3 d-flex flex-column justify-content-end">
//                             <div className="fw-semibold" style={{ whiteSpace: "pre-line" }}>
//                               {item.caption}
//                             </div>
//                           </div>
//                         </div>
//                       );
//                     }

//                     if (item.kind === "stack") {
//                       return (
//                         <div key={key}>
//                           {/* top small image card */}
//                           <div className={`vx-card ratio mt-2 ratio-4x5 text-white ${item.top.tone}`}>
//                             {item.top.img && <img className="vx-bg-img" src={item.top.img} alt={item.top.caption} />}
//                             <div className="p-3 d-flex flex-column justify-content-end">
//                               <div className="fw-semibold" style={{ whiteSpace: "pre-line" }}>
//                                 {item.top.caption}
//                               </div>
//                             </div>
//                           </div>

//                           {/* bottom double card */}
//                           <div className={`vx-card double mt-2 ratio ratio-4x5 text-white ${item.bottom.tone}`}>
//                             <div className="p-4 d-flex flex-column justify-content-end">
//                               <div className="display-5 fw-bold lh-1">{item.bottom.kpi}</div>
//                               <div className="small mt-2 opacity-75">{item.bottom.text}</div>
//                             </div>
//                           </div>
//                         </div>
//                       );
//                     }

//                     // default fallback (double kpi card)
//                     return (
//                       <div key={key} className={`vx-card double ratio ratio-4x5 text-white ${item.tone}`}>
//                         <div className="p-4 d-flex flex-column justify-content-end">
//                           <div className="display-5 fw-bold lh-1">{item.kpi}</div>
//                           <div className="small mt-2 opacity-75">{item.text}</div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </React.Fragment>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* component-scoped styles */}
//       <style>{`
//         :root { --gap: 16px; }

//         .bg-light { margin-top: 70px; }

//         .vx-marquee {
//           overflow: hidden;
//         //   mask-image: linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%);
//         //   -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%);
//         }

//         .vx-track {
//         // border: 1px solid red;
//           display: flex;
//           gap: var(--gap);
//           width: max-content;
//           animation: vx-scroll var(--dur, 36s) linear infinite;
//           align-items: center;
//         }

//         .vx-reverse .vx-track { animation-direction: reverse; }

//         .vx-item { flex: 0 0 auto; width: clamp(220px, 26vw, 280px); }

//         .vx-card {
//         // border: 1px solid red;
//           position: relative;
//           border-radius: 18px;
//           overflow: hidden;
//           box-shadow: 0 12px 24px rgba(0,0,0,.08);
//           width: 250px;
//         }

//         .vx-card.single { height: 320px; }
//         .vx-card.double { height: 250px; }

//         .vx-card .vx-bg-img {
//           position: absolute;
//           inset: 0;
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           filter: saturate(1.1) contrast(1.05) brightness(.95);
//         }

//         .vx-card::after {
//           content: "";
//           position: absolute;
//           inset: auto 0 0 0;
//           height: 55%;
//           background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.55) 100%);
//           pointer-events: none;
//         }

//         /* Gradients */
//         .vx-card.g-cyan    { background: radial-gradient(120% 120% at 20% 10%, #64e7ff, #0066ff 60%, #001a5a); }
//         .vx-card.g-teal    { background: radial-gradient(120% 120% at 80% 0%, #7bf3d4, #00a591 55%, #003a2f); }
//         .vx-card.g-blue    { background: linear-gradient(180deg, #9ed0ff, #2a6fff); }
//         .vx-card.g-amber   { background: radial-gradient(110% 110% at 50% -10%, #ffe29a, #ff9a44 60%, #7a3e00); }
//         .vx-card.g-magenta { background: radial-gradient(120% 120% at 70% 0%, #ffb5e8, #ff4d9d 55%, #5a0032); }
//         .vx-card.g-orange  { background: linear-gradient(180deg, #ffd2a1, #ff7a3c); }
//         .vx-card.g-purple  { background: radial-gradient(120% 120% at 30% 0%, #e0c6ff, #7a4bff 60%, #301a75); }

//         /* Seamless scroll: translate by half because content is duplicated */
//         @keyframes vx-scroll {
//           from { transform: translateX(0); }
//           to   { transform: translateX(-50%); }
//         }

//         .vx-marquee:hover .vx-track { animation-play-state: paused; } /* optional pause */

//         .ratio-4x5 { --bs-aspect-ratio: calc(5/4 * 100%); }

//         @media (max-width: 576px) {
//           .vx-item { width: 72vw; }
//           .vx-card { width: 150px; }
//           .vx-card.single { height: 230px; }
//           .vx-card.double { height: 180px; }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default GridCardSection;


/*************************************************************************************************************************************************/






// import React from "react";

// /* --- image sets --- */
// import smallImg1 from "./Images/gridsmall Img1.png";
// import medium1Img1 from "./Images/gridMedium Img1.png";
// import bigImg1 from "./Images/gridBig Img1.png";
// /**************************************************************************/
// import smallImg2 from "./Images/gridsmall Img2.png";
// import medium1Img2 from "./Images/gridMedium Img2.png";
// import bigImg2 from "./Images/gridBig Img2.png";
// /**************************************************************************/
// import smallImg3 from "./Images/gridsmall Img3.png";
// import medium1Img3 from "./Images/gridMedium Img3.png";
// import bigImg3 from "./Images/gridBig Img3.png";
// /**************************************************************************/
// import smallImg4 from "./Images/gridsmall Img4.png";
// import medium1Img4 from "./Images/gridMedium Img4.png";
// import bigImg4 from "./Images/gridBig Img4.png";
// /**************************************************************************/
// import smallImg5 from "./Images/gridsmall Img5.png";
// import medium1Img5 from "./Images/gridMedium Img5.png";
// import bigImg5 from "./Images/gridBig Img5.png";

// import frameImg1 from './Images/frame1.png';
// import frameImg2 from './Images/frame2.png';
// import frameImg3 from './Images/frame3.png';
// import frameImg4 from './Images/frame4.png';
// import frameImg5 from './Images/frame5.png';

// /* keep your laneItems (not used for content, but preserved) */
// const laneItems = [
//   { kind: "single", tone: "g-orange" },
//   { kind: "stack", top: {}, bottom: {} },
//   { kind: "single", tone: "g-teal" },
//   { kind: "stack", top: {}, bottom: {} },
//   { kind: "single", tone: "g-orange" },
//   { kind: "single", tone: "g-blue" },
//   { kind: "image", tone: "g-amber" },
// ];

// /* cycle indexes – advance across the whole marquee */
// const cycle = { small: 0, big: 0, hero: 0 };

// const smallImgs = [smallImg1, smallImg2, smallImg3, smallImg4, smallImg5];
// const bigImgs = [medium1Img1, medium1Img2, medium1Img3, medium1Img4, medium1Img5];
// const heroImgs = [bigImg1, bigImg2, bigImg3, bigImg4, bigImg5];

// function getNextBySize(size) {
//   if (size === "h-small") {
//     const src = smallImgs[cycle.small % smallImgs.length];
//     cycle.small += 1;
//     return src;
//   }
//   if (size === "h-big") {
//     const src = bigImgs[cycle.big % bigImgs.length];
//     cycle.big += 1;
//     return src;
//   }
//   const src = heroImgs[cycle.hero % heroImgs.length];
//   cycle.hero += 1;
//   return src;
// }

// /* preload helper for silky scroll */
// const preloadAll = (urls) =>
//   Promise.all(
//     urls.map(
//       (u) =>
//         new Promise((res) => {
//           const i = new Image();
//           i.src = u;
//           i.onload = res;
//           i.onerror = res;
//           i.decoding = "async";
//         })
//     )
//   );

// /* tiny renderer */
// function Card({ tone, size }) {
//   const finalImg = getNextBySize(size);
//   return (
//     <div className={`vx-card ${tone || ""} ${size || ""}`}>
//       <span className="vx-spacer" />
//       <img className="vx-bg-img" src={finalImg} alt="" loading="eager" decoding="async" />
//     </div>
//   );
// }

// /* frame */
// function SixColumnFrame() {
//   return (
//     <div className="vx-frame">
//       <div className="vx-col left">
//         <Card size="h-small" tone={laneItems[0]?.tone} />
//         <Card size="h-big" tone={laneItems[1]?.bottom?.tone} />
//       </div>
//       <div className="vx-col center">
//         <Card size="h-hero" tone={laneItems[2]?.tone} />
//       </div>
//       <div className="vx-col right">
//         <Card size="h-big" tone={laneItems[3]?.bottom?.tone} />
//         <Card size="h-small" tone={laneItems[4]?.tone} />
//       </div>
//       <div className="vx-col extraHero">
//         <Card size="h-hero" tone={laneItems[5]?.tone} />
//       </div>
//       <div className="vx-col extraLeft">
//         <Card size="h-small" tone={laneItems[6]?.tone} />
//         <Card size="h-big" tone={laneItems[1]?.bottom?.tone} />
//       </div>
//       <div className="vx-col extraHero">
//         <Card size="h-hero" tone={laneItems[6]?.tone} />
//       </div>
//     </div>
//   );
// }

// const GridCardSection = () => {
//   const [run, setRun] = React.useState(false);

//   React.useEffect(() => {
//     // preload everything, then run the scroll
//     preloadAll([...smallImgs, ...bigImgs, ...heroImgs]).then(() => setRun(true));
//   }, []);

//   return (
//     <section className="py-5 bg-light">
//       <div
//         className="px-5 x-xxl-5 px-6 mx-auto position-relative"
//         style={{
//           maxWidth: "74%",
//           zIndex: 1,
//           marginTop: 60
//         }}
//       >
//         <div style={{
//           marginTop: "-4rem",
//           marginBottom: "5rem"
//         }}
//         >
//           <h2
//             style={{
//               fontSize: "2.5rem",
//               fontFamily: "Inter",
//               fontWeight: 700,
//               color: "#242121ff",
//               lineHeight: 1.2
//             }}
//           >
//             How can business{" "}
//             <span style={{
//               color: "#1DB954",
//               fontFamily: "Inter",
//               fontWeight: 700
//             }}
//             >boost engagement?</span>
//           </h2>
//           <p
//             style={{
//               marginTop: -2,
//               color: "#413e3eff",
//               fontSize: "1.1rem",
//               fontFamily: "Poppins",
//               fontWeight: 300,
//               lineHeight: 1.2
//             }}
//           >
//             With sector-specific solutions crafted to enhance customer journeys and maximize results.
//           </p>
//         </div>


//         {/* triple track for seamless loop */}
//         <div className="vx-marquee" style={{ "--dur": "15s" }}>
//           <div className={`vx-track ${run ? "is-running" : ""}`}>
//             <SixColumnFrame />
//             <SixColumnFrame />
//             <SixColumnFrame />


//           </div>
//         </div>
//       </div>

//       {/* styles – only tiny additions for smoothness */}
//       <style>{`
//         :root{
//           --gapCols: 10px;
//           --gapStack: 10px;
//           --colLeftW: 260px;
//           --colCenterW: 260px;
//           --colRightW: 260px;
//           --colExtraHeroW: var(--colCenterW);
//           --colExtraLeftW: var(--colLeftW);
//           --pt-small: 63.725%;
//           --pt-big: 150.294%;
//           --pt-hero: 218.431%;
//           --wrap: 3; /* number of repeated frames */
//         }

//         .bg-light { margin-top: 90px; }

//         .vx-marquee{ overflow:hidden; contain: content; }
//         .vx-track{
//           display:flex; gap: var(--gapCols); width:max-content; align-items:flex-start;
//           animation: vx-scroll var(--dur, 15s) linear infinite;
//           animation-play-state: paused;
//           will-change: transform;
//           backface-visibility: hidden;
//           transform: translate3d(0,0,0);
//         }
//         .vx-track.is-running{ animation-play-state: running; }

//         @keyframes vx-scroll{
//           from { transform: translate3d(0,0,0); }
//           to   { transform: translate3d(calc(-100% / var(--wrap)),0,0); } 
//         }

//         .vx-frame{ flex:0 0 auto; display:flex; gap:var(--gapCols); align-items:flex-start; }
//         .vx-col{ display:flex; flex-direction:column; gap:var(--gapStack); }
//         .vx-frame > *,.vx-track > *{ flex:0 0 auto; }

//         .vx-col.left{ width: var(--colLeftW); }
//         .vx-col.center{ width: var(--colCenterW); }
//         .vx-col.right{ width: var(--colRightW); }
//         .vx-col.extraHero{ width: var(--colExtraHeroW); }
//         .vx-col.extraLeft{ width: var(--colExtraLeftW); }

//         .vx-card{ position:relative; overflow:hidden; border-radius:18px; display:flex; flex-direction:column; border:none; }
//         .vx-card .vx-spacer{ display:block; width:100%; }
//         .vx-card.h-small .vx-spacer{ padding-top: var(--pt-small); }
//         .vx-card.h-big   .vx-spacer{ padding-top: var(--pt-big); }
//         .vx-card.h-hero  .vx-spacer{ padding-top: var(--pt-hero); border:1px solid #ffffff; border-radius:18px; }

//         .vx-card .vx-bg-img{
//           position:absolute; 
//           inset:0; 
//           width:100%;
//           height:100%;
//           object-fit: cover;
//           filter: saturate(1.05) contrast(1.02) brightness(.98);
//           transform: translateZ(0);
//           will-change: transform;
//         }

//         @media (max-width: 768px){
//           :root{
//             --colLeftW: 200px;
//             --colCenterW: 240px;
//             --colRightW: 200px;
//             --colExtraHeroW: 240px;
//             --colExtraLeftW: 200px;
//           }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default GridCardSection;





import React from "react";
import { motion, useMotionValue, useAnimationFrame } from "framer-motion";

import frameImg1 from './Images/frame1.png';
import frameImg2 from './Images/frame2.png';
import frameImg3 from './Images/frame3.png';
import frameImg4 from './Images/frame4.png';
import frameImg5 from './Images/frame5.png';

const IMAGES = [
  { src: frameImg1, alt: "Frame 1" },
  { src: frameImg2, alt: "Frame 2" },
  { src: frameImg3, alt: "Frame 3" },
  { src: frameImg4, alt: "Frame 4" },
  { src: frameImg5, alt: "Frame 5" },
];

const GridCardSection = () => {
  // marquee motion
  const x = useMotionValue(0);
  const trackRef = React.useRef(null);
  const [paused, setPaused] = React.useState(false);

  /* speed control (pixels/sec). Increase for faster scroll. */
  const SPEED = 110; // was 60 — faster & still smooth

  // RAF loop for ultra-smooth, jitter-free scrolling
  useAnimationFrame((t, delta) => {
    if (paused || !trackRef.current) return;

    const track = trackRef.current;
    const halfWidth = track.scrollWidth / 2;
    const step = (SPEED * delta) / 1000; // px/frame based on time delta

    let next = x.get() - step;
    if (Math.abs(next) >= halfWidth) next += halfWidth; // wrap
    x.set(next);
  });

  return (
    <motion.section
      /* enter animation: fade in + slide up when this section enters viewport */
      initial={{ opacity: 0, y: 48 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      viewport={{ once: true, amount: 0.25 }}
      className="py-5 bg-light vx-dark"
    >
      <div
        className="px-5 x-xxl-5 px-6 mx-auto position-relative"
        style={{
          maxWidth: "74%",
          zIndex: 1,

        }}
      >
        {/* Heading */}
        <div style={{ marginBottom: "4rem" }}>
          <h2
            style={{
              marginTop: "1rem",
              fontSize: "2.5rem",
              fontFamily: "Inter",
              fontWeight: 700,
              color: "#242121ff",
              lineHeight: 1.2,
            }}
          >
            How can business{" "}
            <span style={{ color: "#1DB954", fontFamily: "Inter", fontWeight: 700 }}>
              boost engagement?
            </span>
          </h2>
          <p
            style={{
              marginTop: -2,
              color: "#413e3eff",
              fontSize: "1.1rem",
              fontFamily: "Poppins",
              fontWeight: 300,
              lineHeight: 1.2,
            }}
          >
            With sector-specific solutions crafted to enhance customer journeys
            and maximize results.
          </p>
        </div>

        {/* ===== Marquee (RAF + Framer Motion) ===== */}
        <div
          className="vx-marquee"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <motion.div className="vx-track" ref={trackRef} style={{ x }}>
            {/* duplicate once for seamless loop */}
            {[0, 1].map((dup) => (
              <React.Fragment key={dup}>
                {IMAGES.map((img, i) => (
                  <div className="card-box" key={`${dup}-${i}`}>
                    <img
                      className="card-img"
                      src={img.src}
                      alt={img.alt}
                      loading="eager"
                      decoding="async"
                    />
                  </div>
                ))}
              </React.Fragment>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Styles */}
      <style>{`
        :root {
          /* image size  */
          --scale: 0.18;

          --orig-w: 4835px;
          --orig-h: 3234px;

          --card-w: calc(var(--orig-w) * var(--scale));
          --card-h: calc(var(--orig-h) * var(--scale));

          --gap: 22px;
          --radius: 18px;
        }


        .bg-light.vx-dark {
             background: linear-gradient(180deg, #FAFAFA, #f1f7ffff ) !important;
        }

        /* keep existing gradient EXACTLY as-is */
.bg-light.vx-dark {
  position: relative;              /* allow pseudo-element */
}

/* bottom-only soft blend that matches #f1f7ff palette */
.bg-light.vx-dark::after {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 160px;                   /* adjust 120–240px if you want */
  pointer-events: none;
  z-index: 0;                      /* sit under inner content */
  background: linear-gradient(
    to top,
    rgba(241, 247, 255, 0.95) 0%,  /* #f1f7ff tint near bottom */
    rgba(241, 247, 255, 0.60) 40%,
    rgba(241, 247, 255, 0.00) 100%
  );
}

        
        .vx-marquee {
          overflow: hidden;
          position: relative;
          contain: layout paint style; 
          cursor: default;
        }

        .vx-track {
          display: flex;
          gap: var(--gap);
          width: max-content;
          align-items: center;
          will-change: transform;
          backface-visibility: hidden;
          transform: translate3d(0,0,0);
          pointer-events: none; /* hover pause still works (on container) */
        }

        .card-box {
          flex: 0 0 auto;
          width: var(--card-w);
          height: var(--card-h);
          border-radius: var(--radius);
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          transform: translateZ(0);
          will-change: transform;
          border: 1px solid #f3f0f0ff;
          background: transparent;
          margin-bottom: 2.5rem
        }

        .card-img {
          width: 100%;
          height: 100%;
          object-fit: contain;   /* full image, no crop */
          object-position: center;
          display: block;
          transform: translateZ(0);
          will-change: transform;
          pointer-events: none;
        }

        /* Responsive scaling (optional) */
        @media (max-width: 1024px){
          :root { --scale: 0.14; }
        }
        @media (max-width: 768px){
          :root { --scale: 0.10; }
        }
        @media (max-width: 480px){
          :root { --scale: 0.085; }
        }
      `}</style>
    </motion.section>
  );
};

export default GridCardSection;

